import { Trans } from '@lingui/macro'

import { TabButton, TabsContainer } from '../styleds'

export type GovernanceTab = 'hydrachain' | 'staking' | 'delegation' | 'apr' | 'oracle' | 'vault'

interface GovernanceTabsProps {
  activeTab: GovernanceTab
  onTabChange: (tab: GovernanceTab) => void
}

const tabs: { id: GovernanceTab; label: string }[] = [
  { id: 'hydrachain', label: 'HydraChain' },
  { id: 'staking', label: 'Staking' },
  { id: 'delegation', label: 'Delegation' },
  { id: 'apr', label: 'APR' },
  { id: 'oracle', label: 'Oracle' },
  { id: 'vault', label: 'Vault' },
]

export default function GovernanceTabs({ activeTab, onTabChange }: GovernanceTabsProps) {
  return (
    <TabsContainer>
      {tabs.map((tab) => (
        <TabButton key={tab.id} active={activeTab === tab.id} onClick={() => onTabChange(tab.id)}>
          <Trans>{tab.label}</Trans>
        </TabButton>
      ))}
    </TabsContainer>
  )
}
